import { atom, useAtom } from 'jotai'

export const currentWorkspaceId = atom<string | null>(null)

export const useStateCurrentWorkspaceId = () => useAtom(currentWorkspaceId)
